import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 1 }

import { toRefs, computed } from 'vue';

// Personal libs
import { NotificationTypeEnum } from '@shared/enum/notification.enum';

/**
 * Emits
 */
export interface QDialogTemplateProps {
  title?: string;
  label?: string;
  loadingLabel?: string;
  type?: string;
  disable?: boolean;
  flat?: boolean;
  rounded?: boolean;
  loading?: boolean;
  vClosePopup?: boolean;
  iconLeft?: string;
  iconRight?: string;
  fullWidth?: boolean;
  fullHeight?: boolean;
  isSecondary?: boolean;
  colorClass?: string;
  notificationType?: NotificationTypeEnum;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'QBtnValid',
  props: {
    title: {},
    label: { default: '' },
    loadingLabel: {},
    type: {},
    disable: { type: Boolean, default: false },
    flat: { type: Boolean, default: true },
    rounded: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    vClosePopup: { type: Boolean, default: false },
    iconLeft: {},
    iconRight: {},
    fullWidth: { type: Boolean, default: false },
    fullHeight: { type: Boolean, default: false },
    isSecondary: { type: Boolean, default: false },
    colorClass: {},
    notificationType: {}
  },
  emits: ['click'],
  setup(__props: any, { emit: __emit }) {

// Vendor
const emit = __emit;

/**
 * Component properties
 */
const props = __props;
const {
  label,
  loadingLabel,
  type,
  disable,
  flat,
  rounded,
  loading,
  vClosePopup,
  iconLeft,
  iconRight,
  fullWidth,
  fullHeight,
  title,
  isSecondary,
  colorClass,
  notificationType,
} = toRefs(props);

/**
 * Computed properties
 */
const bgClass = computed<string | undefined>(() => {
  if (notificationType.value == null) {
    if (!isSecondary.value && colorClass.value == null) {
      return 'bg-primary';
    } else if (isSecondary.value && colorClass.value == null) {
      return 'bg-secondary';
    } else {
      return undefined;
    }
  } else {
    return `notification-${notificationType.value}`;
  }
});

const textClass = computed<string | undefined>(() => {
  if (notificationType.value == null) {
    if (!isSecondary.value && colorClass.value == null) {
      return 'text-white';
    } else if (isSecondary.value && colorClass.value == null) {
      return 'text-black';
    } else {
      return undefined;
    }
  } else {
    return undefined;
  }
});

/**
 * Methods
 */
function onOkClick() {
  emit('click');
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
    round: _unref(rounded),
    flat: _unref(flat),
    class: _normalizeClass([
      'set-outline',
      'q-px-sm',
      _unref(colorClass),
      bgClass.value,
      textClass.value,
      { 'full-width': _unref(fullWidth), 'full-height': _unref(fullHeight) },
    ]),
    type: _unref(type),
    onClick: onOkClick,
    disable: _unref(disable),
    loading: _unref(loading),
    title: _unref(title)
  }, {
    loading: _withCtx(() => [
      (!_unref(iconLeft) && !_unref(iconRight))
        ? (_openBlock(), _createBlock(_component_q_spinner, { key: 0 }))
        : _createCommentVNode("v-if", true),
      (_unref(iconLeft))
        ? (_openBlock(), _createBlock(_component_q_spinner, {
            key: 1,
            class: "on-left"
          }))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString(_unref(loadingLabel) ?? _unref(label) ?? '') + " ", 1 /* TEXT */),
      (_unref(iconRight))
        ? (_openBlock(), _createBlock(_component_q_spinner, {
            key: 2,
            class: "on-right"
          }))
        : _createCommentVNode("v-if", true)
    ]),
    default: _withCtx(() => [
      (_unref(iconLeft) && !_unref(iconRight))
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            left: "",
            name: _unref(iconLeft) && !_unref(loading) ? _unref(iconLeft) : undefined,
            class: _normalizeClass([{ 'q-mr-none': !_unref(label) }])
          }, null, 8 /* PROPS */, ["name", "class"]))
        : _createCommentVNode("v-if", true),
      (_unref(label) && _unref(label) != '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(label)), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (_unref(iconRight) && !_unref(iconLeft))
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 2,
            right: "",
            name: _unref(iconRight) && !_unref(loading) ? _unref(iconRight) : undefined
          }, null, 8 /* PROPS */, ["name"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["round", "flat", "class", "type", "disable", "loading", "title"])), [
    [_unref(vClosePopup), _unref(vClosePopup)]
  ])
}
}

})